"use strict";var defaultDS = '6';

var DSData = [
{
  name: '6' },

{
  name: '4',
  flags: 'ds-4' }];



var dsList = DSData.map(function (ds) {return ds.name;});
var dsIconThemes = dsList.map(function (key) {return "ds" + key;});

var dsFilenames = {};
var dsFlags = {};
var flagToDS = [];

DSData.forEach(function (data) {
  var key = data.name;
  var flag = data.flags || '';
  var text = '';
  dsFlags[key] = [];
  if (flag) {
    dsFlags[key].push(flag);
    text = "[" + flag + "]";
  }

  dsFilenames[key] = "./symbol" + text + ".js";
  flagToDS.push(flag);
});

var requireRemap = dsList.
filter(function (key) {return key !== defaultDS;}).
map(function (key) {return (
    Object.assign(
    {
      from: dsFilenames[defaultDS],
      to: dsFilenames[key] },

    { 'if-flag': dsFlags[key].join('') }));});



requireRemap.reverse();

function getDSVersion(dsV) {
  var dsVFull = dsV || defaultDS;
  var dsVCheck = dsVFull.startsWith('ds') ? dsVFull.substring(2) : dsVFull;
  return dsVCheck;
}

function getDSFlags(dsV) {
  var dsVCheck = getDSVersion(dsV);
  var currentA = dsFlags[dsVCheck] || dsFlags[defaultDS];
  var selectedDS = currentA.join('');
  var ret = {};
  if (selectedDS) {
    ret[selectedDS] = true;
  }
  return ret;
}

function getIndexFromFlag(flags) {
  var obj = DSData.findIndex(function (data) {return flags && flags.indexOf(data.flags) > -1;});
  return obj === -1 ? 0 : obj;
}

module.exports = {
  getDSFlags,
  getDSVersion,
  getDSFromFlag: getIndexFromFlag,
  dsFlags,
  dsList,
  dsFilenames,
  requireRemap,
  dsIconThemes,
  defaultDS };